import React, { FC, InputHTMLAttributes, SyntheticEvent, useState } from "react"
import { useField } from "formik"
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"
import clsx from "clsx"

interface FocusEvent<T = Element> extends SyntheticEvent<T> {
  relatedTarget: EventTarget | null
  target: EventTarget & T
}

export const FormikCVC: FC<InputHTMLAttributes<HTMLInputElement>> = ({ ...props }) => {
  // @ts-ignore
  const [field, meta] = useField(props.name)

  const [showPassword, setShowPassword] = useState(false)
  const [isFocused, setIsFocused] = useState(false)

  const errorText = meta.error

  const handleBlur = async (e: FocusEvent<HTMLInputElement>) => {
    field.onBlur(e)
    setIsFocused(false)
  }

  const passwordToggle = () => {
    setShowPassword(!showPassword)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value as string

    if (value.match(/^[0-9]*$/gm)) {
      field.onChange(e)
    }
  }

  function classNameSwitcher() {
    const passwordClass =
      "flex items-center py-2.5 px-3 rounded border border-2 lg:text-base text-sm"

    switch (true) {
      case isFocused:
        return clsx(passwordClass, "border-green")
      case errorText !== undefined:
        return clsx("text-red !border-red", passwordClass)
      default:
        return clsx(passwordClass, "border-grey-ec")
    }
  }

  return (
    <div className={clsx("relative", props.className)}>
      <div className={classNameSwitcher()}>
        <input
          {...field}
          {...props}
          onChange={handleChange}
          className={clsx("w-full", "focus:outline-none focus:shadow-outline")}
          onFocus={() => setIsFocused(true)}
          type={showPassword ? "text" : "password"}
          onBlur={handleBlur}
          maxLength={3}
        />
        <div className="w-[10%] flex justify-end" onClick={passwordToggle}>
          {showPassword ? (
            <AiOutlineEyeInvisible className="cursor-pointer" />
          ) : (
            <AiOutlineEye className="cursor-pointer" />
          )}
        </div>
      </div>
      {errorText && <small className="text-red absolute -bottom-4 left-0">{errorText}</small>}
    </div>
  )
}
